export const openLogin = (data) => {
    return {
        type: 'OPEN_LOGIN',
        data: data
    };
}

export const disableElements = (data) => {
    return {
        type: 'DISABLE_ELEMENTS',
        data: data
    };
}

export const toggleProductInToOrderProducts = (data) => {
    return {
        type: 'TOGGLE_PRODUCT_IN_TO_ORDER_PRODUCTS',
        data: data
    };
}

export const setPrinterIp = (data) => {
    return {
        type: 'SET_PRINTER_IP',
        data: data
    };
}

export const setProductsToOrder = (data) => {
    return {
        type: 'SET_PRODUCTS_TO_ORDER',
        data: data
    };
}

export const setUnreadMessages = (data) => {
    return {
        type: 'UNREAD_MESSAGES',
        data: data
    };
}

export const setPendingOrders = (data) => {
    return {
        type: 'PENDING_ORDERS',
        data: data
    };
}

export const fetchPendingOrders = (data) => {
    return {
        type: 'FETCH_PENDING_ORDERS',
        data: data
    };
}

export const setPendingTenders = (data) => {
    return {
        type: 'PENDING_TENDERS',
        data: data
    };
}

export const fetchPendingTenders = (data) => {
    return {
        type: 'FETCH_PENDING_TENDERS',
        data: data
    };
}

export const openCommentModal = (data) => {
    return {
        type: 'OPEN_COMMENTS',
        data: data
    };
}

export const openMarketingModal = (data) => {
    return {
        type: 'OPEN_MARKETING',
        data: data
    };
}

export const setOwnPrice = (data) => {
    return {
        type: 'SET_OWN_PRICE',
        data: data
    };
}

export const openPartnership = (data) => {
    return {
        type: 'OPEN_PARTNERSHIP',
        data: data
    };
}

export const doAuth = (data) => {
    return {
        type: 'DO_AUTH',
        data: data
    };
}

export const logOut = () => {
    return {
        type: 'DO_LOG_OUT'
    };
}